import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-20 px-4 bg-gradient-to-b from-white to-violet-50" data-id="element-66">
      <div className="max-w-5xl mx-auto text-center" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-68">
          <div className="inline-block mb-8" data-id="element-69">
            <span className="inline-flex items-center px-6 py-2 rounded-full bg-violet-600 text-white text-sm font-semibold tracking-wide" data-id="element-70">
              Workshop en Vivo
            </span>
          </div>

          <h1 className="font-playfair text-5xl md:text-7xl lg:text-8xl font-bold text-gray-900 mb-8 leading-tight" data-id="element-71">
            Construye tu Website{' '}
            <span className="italic text-violet-600" data-id="element-72">Profesional</span> en Menos
            de <span className="italic text-violet-600" data-id="element-73">5 Minutos</span> con IA.
          </h1>

          <p className="text-xl md:text-2xl text-gray-700 mb-12 max-w-4xl mx-auto leading-relaxed font-light" data-id="element-74">
            Sin código. Sin plantillas feas. Sin pagarle $3,000 a un diseñador
            que tarda 3 meses. Deja que la IA lo haga por ti — y sal del
            workshop con tu página ya publicada en internet.
          </p>

          <motion.a href="https://sharontirado.mykajabi.com/offers/JCeY2FLo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-violet-600 to-violet-700 text-white text-lg font-bold rounded-xl shadow-lg hover:shadow-xl transition-all" whileHover={{
          scale: 1.05,
          y: -2
        }} whileTap={{
          scale: 0.98
        }} data-id="element-75">
            QUIERO MI LUGAR AHORA
            <ArrowRightIcon className="w-5 h-5" data-id="element-76" />
          </motion.a>

          <div className="mt-10 flex items-center justify-center gap-4 text-gray-600 text-sm md:text-base" data-id="element-77">
            <span data-id="element-78">100% en Español</span>
            <span className="text-violet-600" data-id="element-79">·</span>
            <span data-id="element-80">En Vivo con Sharon</span>
            <span className="text-violet-600" data-id="element-81">·</span>
            <span data-id="element-82">Grabación Incluida</span>
          </div>
        </motion.div>
      </div>
    </section>;
}